<div class="kt-form w-webkit-fill-available" *ngIf="dropdown.locales.length > 0 && form">
  <div class="kt-content kt-grid__item kt-grid__item--fluid">

    <!-- FILTERS -->
    <div class="kt-portlet kt-portlet--mobile">
      <div class="kt-portlet__body">
        <div class="kt-form kt-form--label-right">
          <div class="row align-items-center">
            <div class="col-xl-12 order-2 order-xl-1 pr-0">
              <form class="row align-items-center" [formGroup]="form">
                <div class="col-12 row mb-2 pr-0">
                  <div class="col-md-1 kt-form__label col-form-label"><label>Status:</label></div>
                  <div class="col-md-2 kt-form__control">
                    <select formControlName="status" class="form-control">
                      <option value="all">All</option>
                      <option [value]="i" *ngFor="let value of dropdown.statuses; let i = index">{{ value }}</option>
                    </select>
                  </div>
                  <div class="col-md-1 kt-form__label col-form-label"><label>Locale:</label></div>
                  <div class="col-md-2 kt-form__control">
                    <select formControlName="settings_locale_id" class="form-control">
                      <option value="all">All</option>
                      <option [value]="value.id" *ngFor="let value of dropdown.locales">{{ value.code }}</option>
                    </select>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="kt-section col-12 row d-flex justify-content-between mb-0 mt-1">
          <div class="dropdown dropdown-inline">
            <kt-search-button [loading]="searchBtnLoading" [disabledButton]="loading" (search)="onSubmitClick()"></kt-search-button>
            <kt-clear-button [loading]="clearBtnLoading" [disabledButton]="loading" (clear)="onSubmitClick(true)"></kt-clear-button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="kt-content kt-grid__item kt-grid__item--fluid">
    <div class="kt-portlet kt-portlet--mobile">
      <div class="kt-portlet__body">

        <!-- DEFAULT FAVICON & LOGO -->
        <div class="kt-section mb-4">
          <div class="default-container" *ngIf="defaultReady; else defaultLoading">
            <form [formGroup]="formContentDefault">
              <div class="row">
                <div class="form-group col mb-3" *ngFor="let slot of slots">
                  <label>{{ slot.label }} <span class="text-danger">*</span></label>
                  <ng-container *ngIf="!uploading['default_' + slot.key]">
                    <label class="btn btn-default btn-sm btn-upload upload-icon mt-0 mb-0" *ngIf="!getDefaultMediaSource(slot.key)">
                      <img src="assets/img/upload-icon.png">
                      <span>Upload</span>
                      <input type="file" hidden [accept]="slot.accept" [disabled]="isUploading('default')" (change)="onUploadDefaultFile($event, slot.key)">
                    </label>
                    <div class="image-upload" *ngIf="getDefaultMediaSource(slot.key)">
                      <img class="position-absolute m-2 trash-icon" src="assets/img/trash-icon.png" (click)="onRemoveDefaultFile(slot.key)">
                      <img class="img-fluid preview-image pointer" [alt]="slot.label" [src]="getDefaultMediaSource(slot.key)" (click)="openImage(getDefaultMediaSource(slot.key))">
                    </div>
                  </ng-container>
                  <div class="spinner-wrapper" *ngIf="uploading['default_' + slot.key]">
                    <mat-progress-spinner mode="indeterminate" diameter="25"></mat-progress-spinner>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col text-right">
                  <button *ngIf="canUpdateDefault" type="button" class="btn btn-success w-100-px"
                    [disabled]="!defaultChanged() || formContentDefault.invalid || isUploading('default') || defaultButtonLoading" (click)="onSaveDefault()">Update</button>
                </div>
              </div>
            </form>
          </div>
          <ng-template #defaultLoading>
            <div class="spinner-wrapper">
              <mat-progress-spinner mode="indeterminate" diameter="25"></mat-progress-spinner>
            </div>
          </ng-template>
        </div>

        <!-- SEASONAL FAVICON & LOGO -->
        <div class="kt-section__content">
          <div class="table-responsive">
            <table class="table table-bordered table-hover table-striped">
              <thead>
                <tr>
                  <th>ID</th>
                  <th class="pr-0">LOCALE</th>
                  <th class="pl-1 pr-5">
                    <div class="dropdown selected-category-container ml-1" *ngIf="displayLocale">
                      <button class="dropdown-toggle d-flex justify-content-center dropdown-box" type="button" data-toggle="dropdown">
                        <p class="mr-1">{{ displayLocale.code | uppercase }}</p>
                        <i class="fa fa-sort-down"></i>
                      </button>
                      <ul class="dropdown-menu dropdown-box-open">
                        <li *ngFor="let value of dropdown.locales" (click)="changeLocale(value)">{{ value.code | uppercase }}</li>
                      </ul>
                    </div>
                  </th>
                  <th>SITE LOGO (DESKTOP)</th>
                  <th>SITE LOGO (MOBILE)</th>
                  <th>SITE FAVICON</th>
                  <th>START DATE</th>
                  <th>END DATE</th>
                  <th>STATUS</th>
                  <th class="text-center">ACTIONS</th>
                </tr>
                <tr *ngIf="canCreate && mode != 'create'">
                  <th colspan="100%" class="px-0">
                    <div class="content-container text-center" (click)="onOpenCreate()">
                      <span><i class="fas fa-plus mr-2"></i>Create New Content</span>
                    </div>
                  </th>
                </tr>
                <tr *ngIf="mode == 'create'">
                  <th colspan="100%" class="px-0">
                    <ng-container *ngTemplateOutlet="editor"></ng-container>
                  </th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let row of rows">
                  <tr [class.editing-row]="isEditingRow(row)">
                    <td>{{ row.id }}</td>
                    <td colspan="2">
                      <div class="locale-list">{{ localeList(row) }}</div>
                    </td>
                    <td *ngFor="let slot of slots">
                      <img *ngIf="displayImage(row, slot.key); else noImage" [src]="displayImage(row, slot.key)" class="image-preview pointer" (click)="openImage(displayImage(row, slot.key))">
                    </td>
                    <td>{{ row.start_date | timezoneDate:'YYYY-MM-DD HH:mm' }}</td>
                    <td>{{ row.end_date ? (row.end_date | timezoneDate:'YYYY-MM-DD HH:mm') : '-' }}</td>
                    <td>
                      <label class="switch">
                        <input type="checkbox" [disabled]="!canEdit && !canUpdateStatus" [checked]="row.status == 1" (change)="onChangeStatus($event, row)">
                        <div class="slider round">
                          <span class="on">ON</span>
                          <span class="off">OFF</span>
                        </div>
                      </label>
                    </td>
                    <td class="text-center">
                      <button *ngIf="canViewDetails || canEdit" matTooltip="View" class="btn btn-elevate btn-sm btn-icon btn-icon-sm" (click)="onToggleEdit(row)">
                        <i class="fas fa-cog"></i>
                      </button>
                    </td>
                  </tr>
                  <tr *ngIf="isEditingRow(row)">
                    <td colspan="100%" class="p-0 editing-row">
                      <ng-container *ngTemplateOutlet="editor"></ng-container>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
              <tbody shared-table-handler [loading]="loading" [dataLength]="dataLength"></tbody>
            </table>
          </div>

          <div class="kt-pagination kt-pagination--brand mt-2" *ngIf="pagination !== undefined">
            <ngb-pagination [pageSize]="pageSize" [(page)]="page" [maxSize]="maxSize" [directionLinks]="true" [boundaryLinks]="true" [rotate]="true" [collectionSize]="pagination.total" (pageChange)="onViewPageBy(page)"></ngb-pagination>
            <div class="kt-pagination__toolbar">
              <select (change)="onPerPage($event)" [(ngModel)]="pageSize" class="form-control kt-font-brand page-size">
                <option [value]="item" *ngFor="let item of dropdown.perPage">{{ item }}</option>
              </select>
              <span class="pagination__desc">Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total | number : '1.0' }} records</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="kt-portlet kt-portlet--mobile" *ngIf="initFailed">
  <div class="kt-portlet__body text-center">
    <p class="mb-3">Failed to load Favicon & Logo settings.</p>
    <button type="button" class="btn btn-brand btn-icon-sm" (click)="loadInit()"><i class="fas fa-redo"></i>Retry</button>
  </div>
</div>

<ng-template #noImage>-</ng-template>

<ng-template #editor>
  <form [formGroup]="formContent" class="create-content-container text-left">
    <div class="row">
      <div class="col-12 mb-2" *ngIf="mode == 'create'">
        <span class="header">Create New Favicon & Logo</span>
      </div>
      <div class="form-group col-3 mb-3" *ngIf="mode == 'create'">
        <label>Status: <span class="text-danger">*</span></label>
        <select formControlName="status" class="form-control">
          <option [ngValue]="i" *ngFor="let value of dropdown.statuses; let i = index">{{ value }}</option>
        </select>
      </div>
      <div class="form-group col-3 mb-3">
        <label>Start Date: <span class="text-danger">*</span></label>
        <div class="input-group date">
          <input class="hidden" [owlDateTime]="dateStartRef" [ngModel]="dateTimeStack?.start_date" [ngModelOptions]="{standalone: true}">
          <input type="text" formControlName="start_date" class="form-control" readonly>
          <span class="input-group-append" [owlDateTimeTrigger]="dateStartRef">
            <span class="input-group-text pointer-calendar"><i class="far fa-calendar-alt"></i></span>
          </span>
          <owl-date-time #dateStartRef></owl-date-time>
        </div>
      </div>
      <div class="form-group col-3 mb-3">
        <label>End Date:</label>
        <div class="input-group date">
          <input class="hidden" [owlDateTime]="dateEndRef" [ngModel]="dateTimeStack?.end_date" [ngModelOptions]="{standalone: true}">
          <input type="text" formControlName="end_date" class="form-control" readonly>
          <span class="input-group-append" [owlDateTimeTrigger]="dateEndRef">
            <span class="input-group-text pointer-calendar"><i class="far fa-calendar-alt"></i></span>
          </span>
          <owl-date-time #dateEndRef></owl-date-time>
        </div>
        <small class="text-danger" *ngIf="formContent.errors?.endBeforeStart">End Date must be on or after Start Date</small>
      </div>
    </div>
    <hr>
    <mat-tab-group animationDuration="0ms" class="form-group mb-0" formGroupName="contents" [(selectedIndex)]="selectedTabIndex">
      <mat-tab *ngFor="let locale of dropdown.locales" [formGroupName]="locale.id" [disabled]="isTabDisabled(locale)">
        <ng-template mat-tab-label>
          <span class="mat-tab">
            {{ locale.code }}
            <div *ngIf="checkContent(locale.id) && !applyToAll" class="icon" (click)="clearContent(locale)">
              <i class="fas fa-times"></i>
            </div>
          </span>
        </ng-template>
        <div class="row m-0">
          <div class="col-12 form-group mb-3 pl-0">
            <label class="mt-1"><input type="checkbox" formControlName="applied_to_all" (change)="onApplyToAll($event, locale)"> &nbsp;Applied to all region & language</label>
          </div>
          <div class="form-group col-3 mb-3 pl-0 pr-4" *ngFor="let slot of slots">
            <label>{{ slot.label }}:</label>
            <ng-container *ngIf="!uploading['seasonal_' + locale.id + '_' + slot.key]">
              <label class="btn btn-default btn-sm btn-upload upload-icon mt-0 mb-0" *ngIf="!getMediaSource(locale.id, slot.key)">
                <img src="assets/img/upload-icon.png">
                <span>Upload</span>
                <input type="file" hidden [accept]="slot.accept" [disabled]="isUploading('seasonal')" (change)="onUploadFile($event, locale.id, slot.key)">
              </label>
              <div class="image-upload" *ngIf="getMediaSource(locale.id, slot.key)">
                <img class="position-absolute m-2 trash-icon" src="assets/img/trash-icon.png" (click)="onRemoveFile(locale.id, slot.key)">
                <img class="img-fluid preview-image pointer" [alt]="slot.label" [src]="getMediaSource(locale.id, slot.key)" (click)="openImage(getMediaSource(locale.id, slot.key))">
              </div>
            </ng-container>
            <div class="spinner-wrapper" *ngIf="uploading['seasonal_' + locale.id + '_' + slot.key]">
              <mat-progress-spinner mode="indeterminate" diameter="25"></mat-progress-spinner>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
    <div class="modal-footer">
      <table class="info mr-3" *ngIf="mode == 'edit' && editing">
        <tr>
          <td class="header-hint">Updated by: {{ editing.updated_by || 'System' }}&nbsp;</td>
          <td class="header-hint" [title]="editing.updated_at ? (editing.updated_at | timezoneDate:'YYYY-MM-DD HH:mm:ss') : 'N/A'">
            {{ editing.updated_at ? (editing.updated_at | timezoneDate:'YYYY-MM-DD HH:mm') : '' }}
          </td>
        </tr>
        <tr>
          <td class="header-hint">Created by: {{ editing.created_by || 'System' }}&nbsp;</td>
          <td class="header-hint" [title]="editing.created_at ? (editing.created_at | timezoneDate:'YYYY-MM-DD HH:mm:ss') : 'N/A'">
            {{ editing.created_at ? (editing.created_at | timezoneDate:'YYYY-MM-DD HH:mm') : '' }}
          </td>
        </tr>
      </table>
      <button type="button" class="btn btn-danger m-0 mr-2" (click)="onCancel()">Cancel</button>
      <button *ngIf="(mode == 'create' && canCreate) || (mode == 'edit' && canEdit)" type="button" class="btn btn-success m-0"
        [disabled]="!hasAnyImage() || formContent.invalid || isUploading('seasonal') || buttonLoading" (click)="onSave()">{{ mode == 'create' ? 'Create' : 'Update' }}</button>
    </div>
  </form>
</ng-template>

<kt-swal-alert [message]="messages$ | async" (confirmed)="reload()"></kt-swal-alert>
